export default __webpack_public_path__ + "static/media/icon-person.e0774dee.svg";